<template>
    <div id="app">
        <CustomNav :info="info" :activePage.sync="activePage" />
        <section class="mian-content">
            <keep-alive
                exclude="newsDetail,schemeDetail,caseDetail,productDetail">
                <router-view />
            </keep-alive>
        </section>
        <CustomFooter :info="info" :activePage.sync="activePage" />
    </div>
</template>
<script>
import { ABOUTINFO } from "./assets/js/api/api";
import CustomFooter from "./components/CustomFooter/CustomFooter.vue";
import CustomNav from "./components/CustomNav/CustomNav.vue";
export default {
    components: {
        CustomFooter,
        CustomNav,
    },
    data() {
        return {
            info: {},
            activePage: 0,
        };
    },
    created() {
        this.getCompanyInfo();
        this.setCurrentPageIndex();
    },
    methods: {
        async getCompanyInfo() {
            const { data, msg } = await ABOUTINFO();
            this.info = data[0];
        },
        setCurrentPageIndex() {
            const navTab = window.sessionStorage.getItem("nav");
            if (navTab) this.activePage = Number(navTab);
        },
    },
};
</script>
<style lang="scss" scoped>
#app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    .mian-content {
        flex: 1;
        background-color: #fafafa;
    }
}
</style>
